import { IServiceFactory } from '../../common/types/service-factory';
import { ApiServiceFactoryBase } from './base/api-service-factory-base';
import { AuthApiService, IAuthApiService } from 'api/services/auth-api-service';

export class AuthApiServiceFactory extends ApiServiceFactoryBase implements IServiceFactory<IAuthApiService> {
	public Create(): IAuthApiService {
		return new AuthApiService(this.apiServiceFactory.Create(), this.appConfigService);
	}
}
